import { LOAD_STATE } from '@/shared/types'
import type { SeriesComprehensiveTopResponse } from '@/server/types'
import { seriesComprehensiveTopApi } from '@/server'

export function logicReputationSeriesRank() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const data = ref<SeriesComprehensiveTopResponse | null>(null)

  async function getData() {
    const res = await useLoadState({
      key: `口碑排行榜`,
      state,
      fn: seriesComprehensiveTopApi,
    })

    if (res?.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getData,
  }
}
